import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IOperateurService} from "../../../../../core/services/operateur.service";

interface IPageMc0093 {
    multiOccurrenceOptions: IMultiOccurrenceOptions
}
/* @ngInject */
export default function Mc0093Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         $stateParams: any,
                                         Operateur: IOperateurService) {
    const vm: IPageMc0093 = this;

    vm.multiOccurrenceOptions = {
        filtres: [
            {
                colonne: 'el1cleint',
                operateur: Operateur.EGALE,
                valeur: $stateParams.el1cleint,
                visible: false
            }
        ],
        colonnesVisibles: [
            {nom: 'blocod'   , largeur: 120},
            {nom: 'blodsc'   , largeur: 300},
            {nom: 'e1bprcdep', largeur: 160},
            {nom: 'e1bmntdep', largeur: 160}
        ],
        formulaire: new Formulaire([
            new FormulaireItem('el1cleint', {
                default: $stateParams.el1cleint,
                hidden: true
            }),
            new FormulaireItem('blocleint'),
            new FormulaireItem('e1bprcdep'),
            new FormulaireItem('e1bmntdep')
        ], {largeurDefaut: 33})
    };
}
